import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import fallback from '~/api/fallback';

export default (http: AxiosInstance) => ({
    async getAutocompleteCollections(query: AppWTFAutocompleteCollectionQuery) {
        const fallbackConfig = fallback<AppWTFAutocompleteCollectionResponse>({
            fallback: {
                data: [],
                status: {
                    code: 404,
                    message: 'Response fallbackApi',
                    msgId: '1'
                }
            }
        });
        const { pattern, size, network } = query;
        const config: AxiosRequestConfig = {
            params: {
                pattern,
                size,
                network
            },
            ...fallbackConfig
        };

        const res = await http.get<AppWTFAutocompleteCollectionResponse>(
            '/autocomplete/collections',
            config
        );
        return res.data;
    },

    async getAutocompleteNfts(query: AppWTFAutocompleteNftsQuery) {
        const fallbackConfig = fallback<AppWTFAutocompleteNftsResponse>({
            fallback: {
                data: [],
                status: {
                    code: 404,
                    message: 'Response fallbackApi',
                    msgId: '1'
                }
            }
        });
        const { pattern, size, network, collection } = query;
        const config: AxiosRequestConfig = {
            params: {
                pattern,
                network,
                collection,
                size
            },
            ...fallbackConfig
        };
        const res = await http.get<AppWTFAutocompleteNftsResponse>(
            '/autocomplete/nfts',
            config
        );
        return res.data;
    }
} as const);
